/* ==========================================================================
   Ambury cart drawer support.

   Deliberately small. Dawn's cart-drawer.js already binds #cart-icon-bubble,
   opens the drawer, traps focus, closes on Esc and scrim click, and returns
   focus to the trigger. This file only adds the three things it does not do:

     1. scrollbar-width compensation, so the page does not shift on open
     2. upgrading any other element marked [data-ambury-cart-open] into a
        drawer opener, while leaving it a real link for the no-JS case
     3. suppressing animation inside the theme editor

   No scroll listeners. No libraries.
   ========================================================================== */
(function () {
  'use strict';

  /* --- 1. scrollbar width, measured once ---------------------------------- */
  function setScrollbarWidth() {
    var w = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--ambury-sbw', (w > 0 ? w : 0) + 'px');
  }

  setScrollbarWidth();

  /* Recompute on resize only - a resize listener is cheap and is not a scroll
     listener. Coalesced with rAF so it never runs more than once a frame. */
  var pending = false;
  window.addEventListener(
    'resize',
    function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        setScrollbarWidth();
      });
    },
    { passive: true }
  );

  /* --- 2. extra cart triggers --------------------------------------------- */
  function drawer() {
    return document.querySelector('cart-drawer');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-ambury-cart-open]');
    if (!trigger) return;

    var d = drawer();
    /* No drawer in the DOM (cart_type is not 'drawer'), or the element has not
       upgraded yet - let the link navigate to /cart rather than dead-end. */
    if (!d || typeof d.open !== 'function') return;

    event.preventDefault();
    d.open(trigger);
  });

  /* --- 3. theme editor: no motion while editing --------------------------- */
  function applyEditorGuard() {
    if (!window.Shopify || !window.Shopify.designMode) return;
    var d = drawer();
    if (d) d.classList.add('ambury-no-motion');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyEditorGuard);
  } else {
    applyEditorGuard();
  }
})();
